/*=================================================
    summary: 學生作答 填空題型 FillIn 單元 
             練習 寫一寫                LUSeqNo: 26         
             複習 寫作                  LUSeqNo: 27

             Practice Writing Grammar Exercises
             Review Writing Grammar Exercises

             撈資料 與 Header在這邊做

    remarks: 000 Tim 2022/01/03 Create
             001 Tim 2022/01/14 串接 LanguageChangeHandler 流程
             002 Tim 2022/03/14 補上 BlockedInstructor 機制
=================================================*/
import React, { useEffect, useState, useRef, useContext } from 'react'
import cssFillInMain from './FillInMain.module.scss'

import FillInContent from '../FillInContent/FillInContent'

import { LUCacheContext } from '../../../LearningUnit.js'
// import GoogleShareToClassRoom from '../../../../Utils/GShare.js'
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs, NetworkLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "FillInMain"
// #endregion Constant

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let mstrLUKey4LUCachedContext = "" // 用於從LUCacheContext 取出 Cache的LU資料時 指出此LU時所需的Key
let mstrBookCatID = ""
let mstrLUCatSeqNo = ""

let mfuncLanguageChangeHandler = null

let mstrMessage4BlockedInstructor = ""
// #endregion Member Variables

function FillInMain(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [isBlockedInstructor, setIsBlockedInstructor] = useState(false)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)

    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region Init Context Ref
    // History, Temp, 都是 Cached 在這裏
    let mobjLUCacheContext = useContext(LUCacheContext)
    console.log("mobjLUCacheContext: ", mobjLUCacheContext)
    // #endregion Init Context Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)

        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)

        mblnInitialized = true
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            mblnInitialized = false
            mstrLUKey4LUCachedContext = ""
            mstrLUCatSeqNo = ""
            mfuncLanguageChangeHandler = null       // 這邊離開 會 移除 所以 FillInContent 不做反註冊  Tim22.01.14

            mstrMessage4BlockedInstructor = ""

            setUpdateDataTime(0)
            setIsBlockedInstructor(false)
        }
    }, [props.LUInfo])
    // #endregion useEffect

    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function PaintedMe()
    {
        // console.log(COMP_NAME + ".PaintedMe: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".PaintedMe BEGIN")

        RegisterLanguageChangeHandler()

        mstrLUKey4LUCachedContext = "LU" + props.LUInfo.LUCatSeqNo // 用於Cache LU資料時 指出此LU的Key
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo

        console.log(COMP_NAME + ".PaintedMe mstrLUKey4LUCachedContext: ", mstrLUKey4LUCachedContext)
        console.log(COMP_NAME + ".PaintedMe mstrLUCatSeqNo: ", mstrLUCatSeqNo)

        let objHistoryList = mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]
        if (
            (typeof (objHistoryList) === 'undefined') || 
            (objHistoryList === null) || 
            (typeof (objHistoryList.LessonID) === 'undefined') || 
            (objHistoryList.LessonID === null) || 
            (parseInt(objHistoryList.LessonID) <= 0) || 
            (objHistoryList.LessonID !== props.LessonID)
            )
        {
            console.log("need to get Assignment History")

            GetPrerequisiteDataProcessBegin()
        }
        else
        {
            console.log("need Not to get Assignment History")
            GetPrerequisiteDataProcessEnd()
        }
    } // end of PaintedMe
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: 點選 子子單元
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function SubSubSectionOnTapHandler()
    {
        console.log(COMP_NAME + ".SubSubSectionOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let intLUCatSeqNo = 0
        if (parseInt(mstrLUCatSeqNo) === window.gDCPLUEnum.PracticeWritingGrammarExercises)
        {
            // 練習 寫一寫                LUSeqNo: 26
            // GoToLU -> 練習 寫一寫        LUSeqNo: 18
            intLUCatSeqNo = window.gDCPLUEnum.PracticeWritingComposition
        }
        else if (parseInt(mstrLUCatSeqNo) === window.gDCPLUEnum.ReviewWritingGrammarExercises)
        {
            // 複習 寫作                  LUSeqNo: 27
            // GoToLU -> 複習 寫一寫        LUSeqNo: 22
            intLUCatSeqNo = window.gDCPLUEnum.ReviewWritingComposition
        }

        let objCallbackData = {
            "Action": "GoToLU",
            "LUCatSeqNo": intLUCatSeqNo
        }

        console.log("objCallbackData:", objCallbackData)
        props.CallbackRef(objCallbackData)
    } // end of SubSubSectionOnTapHandler

    /*===========================================
    summary: App 點選 GoogleClassroom 元件
    remarks: 000 Tim 2022/01/03 Create
             001 Tim 2023/06/14 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置
        
        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler
    // #endregion OnTapHandler

    // #region Other Handler
    /*===========================================
    summary: 語言設定 改變 事件
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function LanguageOnChangeHandler()
    {
        // console.log(COMP_NAME + ".LanguageOnChangeHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".LanguageOnChangeHandler BEGIN")
        
        // 這一層 本身沒做事

        if (mfuncLanguageChangeHandler !== null)
        {
            mfuncLanguageChangeHandler()
        }
    } // end of LanguageOnChangeHandler
    // #endregion Other Handler

    // #region LoadingMask and Alert
    /*===========================================
    summary: 開啟 LoadingMask
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 LoadingMask
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask
    // #endregion LoadingMask and Alert

    // #region Component Callback
    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "RegisterLanguageChangeHandler")
        {
            mfuncLanguageChangeHandler = CallbackObj.Function
        }
        else if (CallbackObj.Action === "UpdateCacheSinceSubmit")
        {
            InitBlockedInstructor()
        }
        else
        {
            // 其他 事件 直接往上送
            props.CallbackRef(CallbackObj)
        }
    } // end of ComponentCallback
    // #endregion Component Callback

    // #region Other Functions
    /*===========================================
    summary: 註冊 語言改變事件
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function RegisterLanguageChangeHandler()
    {
        // console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler BEGIN")

        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    } // end of RegisterLanguageChangeHandler

    /*===========================================
    summary: 取得 必要資料 流程 開始
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function GetPrerequisiteDataProcessBegin()
    {
        console.log(COMP_NAME + ".GetPrerequisiteDataProcessBegin")

        // 2 Steps:
        // 1. History
        // 2. Temp Answer List

        // Func: "GetNewAssignmentAssignAnswer"
        // AssignID: -1
        // Assignee: 459
        // BookCategoryID: "03"
        // LUCatSeqNo: 14
        // LessonID: "03001"

        mobjCallParam = {
            "Assignee": window.gSession.Acc.ID,
            "BookCategoryID": mstrBookCatID,
            "LessonID": props.LessonID,
            "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
            "AssignID": -1
        }
        GetAssignmentAssignAnswer()
    } // end of GetPrerequisiteDataProcessBegin

    /*===========================================
    summary: 取得 必要資料 流程 結束
    remarks: 000 Tim 2022/01/03 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function GetPrerequisiteDataProcessEnd()
    {
        console.log(COMP_NAME + ".GetPrerequisiteDataProcessEnd")

        console.log("mobjLUCacheContext.AssigementHistoryList: ", mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext])
        console.log("mobjLUCacheContext.AssignmentTempAnsList: ", mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext])

        InitBlockedInstructor()

        setUpdateDataTime(new Date().getTime())
    } // end of GetPrerequisiteDataProcessEnd

    /*===========================================
    summary: 初始化 鎖住作答
    remarks: 000 Tim 2022/03/14 Create
    ===========================================*/
    function InitBlockedInstructor()
    {
        console.log(COMP_NAME + ".InitBlockedInstructor: ")

        let intAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)

        if (intAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
        {
            let intAssignCount = 0
            if (
                (typeof(mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]) !== "undefined") &&
                (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext] !== null) &&
                (typeof(mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList) !== 'undefined') &&
                (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList !== null) &&
                (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length > 0)
                )
            {
                intAssignCount = mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length
            }
            console.log(COMP_NAME + ".InitBlockedInstructor intAssignCount: ", intAssignCount)
            // console.log(COMP_NAME + ".InitBlockedInstructor LUCatSeqNo: ", props.LUInfo.LUCatSeqNo)
            // console.log(COMP_NAME + ".InitBlockedInstructor IsDCPSectionPracticeShow: ", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow)
            // console.log(COMP_NAME + ".InitBlockedInstructor IsDCPSectionHWShow: ", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionHWShow)
            // console.log(COMP_NAME + ".InitBlockedInstructor DCPTestedCountMax: ", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax)
            // 學生身份
            let strMsg = ""
            if (
                    // 關閉 Practice 要判斷
                    // "PracticeWritingGrammarExercises": 26
                    (
                        (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 0) &&
                        (parseInt(props.LUInfo.LUCatSeqNo) === window.gDCPLUEnum.PracticeWritingGrammarExercises)
                    ) ||

                    // 關閉 Review 要判斷
                    // "ReviewWritingGrammarExercises": 27
                    (
                        (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionHWShow) === 0) &&
                        (parseInt(props.LUInfo.LUCatSeqNo) === window.gDCPLUEnum.ReviewWritingGrammarExercises)
                    )
                )
            {
                // 老師關閉 Practice 或 Review
                strMsg = window.gAppUI.MSG_Alert_Msg_BlockedInstructor
            }
            else if (
                (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) <= 2) &&
                (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) <= intAssignCount)
                )
            {
                // 作答次數 超過 設定值
                if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) === 1)
                {
                    // 作答次數 超過 一次
                    strMsg = window.gAppUI.MSG_Alert_Msg_TestedCountExceededOnce
                }
                else
                {
                    // 作答次數 超過 兩次
                    strMsg = window.gAppUI.MSG_Alert_Msg_TestedCountExceededTwice
                }
            }

            if (strMsg !== "")
            {
                mstrMessage4BlockedInstructor = strMsg
                setIsBlockedInstructor(true)
            } // end of if (strMsg !== "")
        } // end of if (intAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
    } // end of InitBlockedInstructor
    // #endregion Other Functions

    // #region Web Service After Process
    /*===========================================
    summary: 取得考卷 暫存資料 後續流程
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function GetNewAssignmentAssignTmpAnswerAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetNewAssignmentAssignTmpAnswerAfterProcess: ", ReturnData)

        console.log("mobjLUCacheContext: ", mobjLUCacheContext)
        mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext] = ReturnData

        GetPrerequisiteDataProcessEnd()
    } // end of GetNewAssignmentAssignTmpAnswerAfterProcess

    /*===========================================
    summary: 取得考卷 歷史紀錄 資料 後續流程
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function GetAssignmentAssignAnswerAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswerAfterProcess: ", ReturnData)

        // 更新 Cache
        mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext] = ReturnData

        console.log("完成 Step 1, 需進行 Step 2")

        // 取得 Temp Answer List

        // Func: "GetNewAssignmentAssignAnswer"
        // AssignID: -1
        // Assignee: 459
        // BookCategoryID: "03"
        // LUCatSeqNo: 11
        // LessonID: "03001"

        mobjCallParam = {
            "Assignee": window.gSession.Acc.ID,
            "BookCategoryID": mstrBookCatID,
            "LessonID": props.LessonID,
            "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
            "AssignID": -1
        }
        GetNewAssignmentAssignTmpAnswer()
    } // end of GetAssignmentAssignAnswerAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 取得考卷 歷史紀錄 資料
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function GetAssignmentAssignAnswer()
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswer: ", props.LUInfo.LUCatSeqNo)

        let objRetryFuncRef = GetAssignmentAssignAnswer
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetAssignmentAssignAnswerCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAssignmentAssignAnswer)

            let objCallData = {
                "Func": "GetNewAssignmentAssignAnswer",
                "Assignee": mobjCallParam.Assignee,
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "LUCatSeqNo": mobjCallParam.LUCatSeqNo,
                "AssignID": mobjCallParam.AssignID
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetAssignmentAssignAnswer

    /*===========================================
    summary: 取得考卷 歷史紀錄 資料 Callback
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function GetAssignmentAssignAnswerCallback(Return)
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswerCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetAssignmentAssignAnswer_No
        let strErrorTitle = window.gAppUI.ERR_GetAssignmentAssignAnswer_Title
        let strErrMsg = window.gAppUI.ERR_GetAssignmentAssignAnswer_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute)
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetAssignmentAssignAnswerCallback: ErrNo: ", Return.ErrNo)
            console.log("GetAssignmentAssignAnswerCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetAssignmentAssignAnswerCallback Return.Data", Return.Data)

            GetAssignmentAssignAnswerAfterProcess(Return.Data)
        }
    } // end of GetAssignmentAssignAnswerCallback

    /*===========================================
    summary: 取得考卷 暫存資料
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function GetNewAssignmentAssignTmpAnswer()
    {
        console.log(COMP_NAME + ".GetNewAssignmentAssignTmpAnswer: ")
        let objRetryFuncRef = GetNewAssignmentAssignTmpAnswer
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Title, window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetNewAssignmentAssignTmpAnswerCallback

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetNewAssignmentAssignTmpAnswer)

            let objCallData = {
                "Func": "GetNewAssignmentAssignTmpAnswer",
                "Assignee": mobjCallParam.Assignee,
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "LUCatSeqNo": mobjCallParam.LUCatSeqNo,
                "AssignID": mobjCallParam.AssignID
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetNewAssignmentAssignTmpAnswer

    /*===========================================
    summary: 取得考卷 暫存資料 Callback
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function GetNewAssignmentAssignTmpAnswerCallback(Return)
    {
        console.log(COMP_NAME + ".GetNewAssignmentAssignTmpAnswerCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetNewAssignmentAssignAnswer_No
        let strErrorTitle = window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Title
        let strErrMsg = window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Msg


        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetNewAssignmentAssignTmpAnswerCallback: ErrNo: ", Return.ErrNo)
            console.log("GetNewAssignmentAssignTmpAnswerCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetNewAssignmentAssignTmpAnswerCallback Return.Data", Return.Data)
            GetNewAssignmentAssignTmpAnswerAfterProcess(Return.Data)
        }
    } // end of GetNewAssignmentAssignTmpAnswerCallback
    // #endregion Web Service

    // #region Component
    /*===========================================
    summary: 中文標題 顯示Component  
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function ComponentTitleCN( {PropsSubSectionDef} )
    {   
        let strTitleCN = ""
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = PropsSubSectionDef.MajorName
        }
        else
        {
            strTitleCN = PropsSubSectionDef.MinorName
        }

        return(
            <div className={cssFillInMain.divLUTitleTextCN}>
                {strTitleCN}
            </div>
        )
    } // end of ComponentTitleCN
    // #endregion Component

    // #region Render
    /*===========================================
    summary: Render Blocked Instructor 的顯示
    remarks: 000 Tim 2022/03/14 Create
    ===========================================*/
    function RenderBlockedInstructorWrapper(StateIsBlockedInstructor)
    {
        if (StateIsBlockedInstructor)
        {
            return (
                <div className={cssFillInMain.divBlockedInstructor}>
                    {mstrMessage4BlockedInstructor}
                </div>
            )
        }
        else 
        {
            return ""
        }
    } // end of RenderBlockedInstructorWrapper

    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))            
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if(intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssFillInMain.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }
        
        return objBlockGoogleClassroomButton
    } // end of RenderGoogleClassrommButton

    /*===========================================
    summary: Render Header 右邊  區塊 的顯示
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function RenderHeaderRightAreaWrapper()
    {
        // console.log(COMP_NAME + ".RenderHeaderSubSubSectionToolArea props.SubSectionDef: ", props.SubSectionDef)
        // props.SubSectionDef:  
        // SubSubSection: Array(2)
        // 0: {SubSubSectionSeqNo: '06', Name: 'Grammar Exercises', MajorName: '句型练习', MinorName: '句型練習', LUCatSeqNo: '26'}
        // 1: {SubSubSectionSeqNo: '07', Name: 'Composition', MajorName: '写一写', MinorName: '寫一寫', LUCatSeqNo: '18'}

        return (
            <div className={cssFillInMain.divTitleRightArea}>
                <div className={cssFillInMain.divSubSubSectionToolArea}>
                    <div className={cssFillInMain.btnSubSubSectionDisalbed}>
                        {props.SubSectionDef.SubSubSection[0].Name}
                    </div>
                    <div className={cssFillInMain.btnSubSubSection} onClick={() => SubSubSectionOnTapHandler()}>
                        {props.SubSectionDef.SubSubSection[1].Name}
                    </div>
                </div>
            </div>
        )
    } // end of RenderHeaderRightAreaWrapper

    /*===========================================
    summary: Render Header 左邊區塊 的顯示
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function RenderHeaderLeftAreaWrapper()
    {
        return (
            <div className={cssFillInMain.divTitleLeftArea}>
                {RenderGoogleClassrommButton()}

                <div className={cssFillInMain.divTitleSubArea}>
                    <div className={cssFillInMain.divLessonIcon}/>

                    <div className={cssFillInMain.divLUTitleTextEN}>
                        {props.SubSectionDef.Name}
                    </div>

                    <div className={cssFillInMain.divDividerBar}/>

                    <ComponentTitleCN PropsSubSectionDef={props.SubSectionDef} />
                </div>
            </div>
        )
    } // end of RenderHeaderLeftAreaWrapper

    /*===========================================
    summary: Render Header 的顯示
    remarks: 000 Tim 2022/01/03 Create
    ===========================================*/
    function RenderHeaderWrapper()
    {
        return (
            <>
                {RenderHeaderLeftAreaWrapper()}
                {RenderHeaderRightAreaWrapper()}
            </>
        )
    } // end of RenderHeaderWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2022/01/03 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime, StateIsBlockedInstructor)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssFillInMain.divContent}>
                    <FillInContent LUInfo={props.LUInfo} 
                        LessonID={props.LessonID}
                        SubSectionDef={props.SubSectionDef}
                        UpdateDataTime={StateUpdateDataTime}
                        IsBlockedInstructor={StateIsBlockedInstructor}
                        CallbackRef={ComponentCallback}/>

                    {RenderBlockedInstructorWrapper(StateIsBlockedInstructor)}
                </div>
            )
        }
        else 
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2022/01/03 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <>
                {RenderHeaderWrapper()}
                {RenderContentWrapper(updateDataTime, isBlockedInstructor)}
            </>
        )
    } // end of RenderMainWrapper

    return (
        <>        
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default FillInMain